import { makeStyles } from '@mui/styles';
import { styles } from '@tcs/create-account/utils/theme';

export const useStyles = makeStyles({
  wrapper: {
    marginBottom: `${styles.spacing(6)}px`,
  },
});
